import * as React from 'react'

import Button from '@doordash/component-button'

import t from './strings'

type BackButtonTypesProps = {
  onClick?: any
}
const BackButton: React.SFC<BackButtonTypesProps> = props => (
  <Button
    onClick={props.onClick}
    type={Button.Types.TertiaryPill}
    size={Button.Sizes.Small}
    isInline
  >
    {`< ${t.back()}`}
  </Button>
)
BackButton.defaultProps = {
  onClick: console.log,
}
export default BackButton
